import React from 'react';
import { connect } from "react-redux";
import { Row, Col, Card, CardBody } from 'reactstrap';

//Componentes auxiliares:
import HelpButton from '../layouts/mainLayout/components/HelpButton';
import DateFilterManager from '../components/auditView/DateFilterManager';
import AuditRecordsTable from '../components/auditView/AuditRecordsTable';
import ChecksFilterManager from '../tools/components/ChecksFilterManager';

//Contenido del tour de ayuda:
import { auditViewTourConfig } from './tours/AuditView';

//Scripts auxiliares:
import { getFilteredArray } from '../tools/scripts/arrayManagement';
import { getTranslatedAuditRecordType, getAuditRecordParentName } from './common/auditRecordsRenderingFunctions';

class AuditView extends React.Component {

    constructor() {
        super();

        this.state = {
            activeQuantity: 5,
            toDate: new Date(),
            filterShouldBePrinted: false,
            fromDate: new Date(new Date().getTime() - (10 * 24 * 60 * 60 * 1000)),

            targetAuditRecords: [],
            originalAuditRecords: [],

            auditRecordsTypes: [],
        }
    }

    render() {
        return (
            <div className="content" >
                <div className="content">
                    <Row>
                        <Col xs="12" md="12" lg="4" xl="4">
                            <Card data-tut="reactour__auditView.filterManagerBasedOnDate">
                                <CardBody>
                                    <DateFilterManager
                                        title="Filtros por fechas:"
                                        resetDates={this.resetDates}
                                        activeQuantity={this.state.activeQuantity}
                                        totalRegisters={this.state.targetAuditRecords.length}
                                        updateToDate={this.updateToDate} currentToDate={this.state.toDate}
                                        updateFromDate={this.updateFromDate} currentFromDate={this.state.fromDate} />
                                </CardBody>
                            </Card>

                            <div data-tut="reactour__auditView.filterManagerBasedOnType">
                                <ChecksFilterManager
                                    title="Tipos de registro:"
                                    filteringKey={"event_type"}
                                    managerKey={"auditView.auditRecordType"}
                                    originalData={this.state.originalAuditRecords}
                                    filteringOptions={this.state.auditRecordsTypes}
                                    originalFilters={this.props.auditRecordsTypeFilters}
                                    filteredDataCallback={this.updateFilteredAuditRecords}

                                    activeQuantity={this.state.activeQuantity}
                                    totalRegisters={this.state.targetAuditRecords.length}

                                    itemRendering={(item) => {
                                        return (
                                            <React.Fragment>
                                                <span>{getAuditRecordParentName(item.event_type) + ": "}</span>
                                                <b>{getTranslatedAuditRecordType(item.event_type)}</b>
                                            </React.Fragment>
                                        );
                                    }} />
                            </div>
                        </Col>

                        <Col xs="12" md="12" lg="8" xl="8">
                            <Card data-tut="reactour__auditView.auditRecordsTable">
                                <CardBody>
                                    <div className="card-without-scrollbar">
                                        <AuditRecordsTable
                                            targetData={this.state.targetAuditRecords}
                                            activeQuantity={this.state.activeQuantity}
                                            updateActiveQuantity={this.updateActiveQuantity} />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.props.changeRelatedNavbarButtons([
            <HelpButton tourContent={auditViewTourConfig} />
        ]);

        let lastAuditDates = this.props.auditDateFilterDates;

        if (lastAuditDates.toDate && lastAuditDates.fromDate) {
            this.fetchRecordsBasedOnDates(lastAuditDates.fromDate, lastAuditDates.toDate);
            this.saveDatesInTemporalsReducer(lastAuditDates.fromDate, lastAuditDates.toDate);
        }
        else {
            this.fetchRecordsBasedOnDates(this.state.fromDate, this.state.toDate);
        }
    }

    //Métodos operativos:
    fetchRecordsBasedOnDates = (fromDate, toDate) => {
        window.document.body.style.cursor = "wait";
        fetch(process.env.REACT_APP_API_URL + "/auditRecords/?from_date="
            + fromDate.toISOString() + "&to_date=" + toDate.toISOString(), {
            method: "GET",
            headers: { "Authorization": "Token " + this.props.activeUser.authToken }
        })
            .then((serverResponse) => {
                switch (serverResponse.status) {
                    case 200:
                        serverResponse.json()
                            .then((auditRecords) => {
                                let processedAuditRecords = [];
                                for (let i = 0; i < auditRecords.length; i++) {
                                    processedAuditRecords.push({
                                        ...auditRecords[i],
                                        userEmail: auditRecords[i].user.email
                                    });
                                }

                                processedAuditRecords = processedAuditRecords.filter(item =>
                                    item.user.country_scope === this.props.activeUser.country_scope);

                                this.setState({
                                    filterShouldBePrinted: true,
                                    originalAuditRecords: processedAuditRecords,
                                    auditRecordsTypes: this.getAuditRecordsTypes(processedAuditRecords)
                                });

                                window.document.body.style.cursor = "default";
                            });
                        break;

                    default:
                        window.document.body.style.cursor = "default";
                        console.log("Error fetching audit records...");
                        break;
                }
            })
            .catch((error) => { window.document.body.style.cursor = "default"; console.log(error); });
    }

    getAuditRecordsTypes = (auditRecords) => {
        let recordsArray = [];
        auditRecords.forEach((auditRecord) => { recordsArray.push(auditRecord.event_type) });

        let nonDuplicatedArray = [...new Set(recordsArray)];
        return nonDuplicatedArray.map((item, i) => { return ({ "event_type": item }) });
    }

    resetDates = () => {
        let toDate = new Date();
        let fromDate = new Date(new Date().getTime() - (1 * 24 * 60 * 60 * 1000));

        this.fetchRecordsBasedOnDates(fromDate, toDate);
        this.saveDatesInTemporalsReducer(fromDate, toDate);
    }

    saveDatesInTemporalsReducer = (fromDate, toDate) => {
        this.setState({
            toDate: toDate,
            fromDate: fromDate
        });

        this.props.changeAuditDateFilterDates({
            toDate: toDate,
            fromDate: fromDate
        });
    }

    updateActiveQuantity = (newQuantity) => {
        this.setState({ activeQuantity: newQuantity });
    }

    updateFilteredAuditRecords = (newFilters) => {
        let filteredItems = getFilteredArray(this.state.originalAuditRecords, newFilters, "event_type");
        this.setState({ targetAuditRecords: filteredItems });

        this.props.changeAuditRecordsTypeFilters(newFilters);
    }

    updateFromDate = (newFromDate) => {
        this.fetchRecordsBasedOnDates(newFromDate, this.state.toDate);
        this.saveDatesInTemporalsReducer(newFromDate, this.state.toDate);
    }

    updateToDate = (newToDate) => {
        this.fetchRecordsBasedOnDates(this.state.fromDate, newToDate);
        this.saveDatesInTemporalsReducer(this.state.fromDate, newToDate);
    }
}

const mapdispatchToProps = dispatch => {
    return {
        changeRelatedNavbarButtons: (navbarButtons) => dispatch({ type: "changeNavbarButtons", navbarButtons: navbarButtons }),
        changeAuditDateFilterDates: (newDatesItem) => dispatch({ type: "changeAuditDateFilterDates", newAuditDateFilterDates: newDatesItem }),
        changeAuditRecordsTypeFilters: (newFilters) => dispatch({ type: "changeAuditRecordsTypeFilters", newAuditRecordsTypeFilters: newFilters }),
    };
};

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost,
        auditDateFilterDates: state.temporalsReducer.auditDateFilterDates,
        auditRecordsTypeFilters: state.temporalsReducer.auditRecordsTypeFilters
    };
};

export default connect(mapStateToProps, mapdispatchToProps)(AuditView);